module.exports = __webpack_public_path__ + "img/stock5.e5388ab0.png";